import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class Agreement extends RestResource {
  name = ""
  slug = ""
  version = ""
  url = ""
  s3Bucket = ""
  s3Key = ""
  context = ""
  regulatoryDomain = ""
  acceptanceType = ""
}
export class AgreementAcceptance {
  agreedAt: Date | null = null
  acceptanceMethod = ""
  document = new Agreement()
}
export const AGREEMENT_DESER: SchemaDeSer<Agreement> = new SchemaDeSerBuilder(
  Agreement
)
  .ofString("name")
  .ofString("slug")
  .ofString("version")
  .ofString("url")
  .ofString("s3Bucket")
  .ofString("s3Key")
  .ofString("context")
  .ofString("regulatoryDomain")
  .ofString("acceptanceType")
  .toDeSer()

export const AGREEMENT_ACCEPTANCE_DESER: SchemaDeSer<AgreementAcceptance> =
  new SchemaDeSerBuilder(AgreementAcceptance)
    .ofString("acceptanceMethod")
    .ofDateTime("agreedAt")
    .ofNested("document", AGREEMENT_DESER, Agreement)
    .toDeSer()

export interface AgreementInput {
  slug: string
  version: string
}
